(function () {
  'use strict';
   //the rest of the function
}());

var powerbi=null;
var am = angular.module('ep-dealer-revenue-share', ['ui.router', 'powerbi']);
am.config(['$stateProvider', (function($stateProvider) {
  $stateProvider.state('dealer-revenue-share', {
    url: '/dealer-revenue-share/:view',
    templateUrl: 'feature/program/dealer-revenue-share/dealer-revenue-share.html',
    controller: 'dealerRevenueShareCtrl'
  });
})]);
am.factory('dealerRevenueShareTileSvc', ['$http', 'rest', (function($http, rest) {
  var svc = {};
  svc.tileMetrics = (function() {
    var url = (rest.getRestUrlPrefix() + "databus/dealer-revenue-share/tile-metrics");
    return $http.get(url);
  });
  svc.isFullAccess = (function() {
    var url = (rest.getRestUrlPrefix() + "reports/has-rev-share-dashboard-full-access");
    return $http.get(url);
  });
  return svc;
})]);
am.controller('dealerRevenueShareTileCtrl', ['$scope', '$rootScope', '$state', 'dealerRevenueShareTileSvc', 'googleAnalyticsSvc', 'mtzProfileSvc', 'loginSvc', 'loadLanguage', (function($scope, $rootScope, $state, dealerRevenueShareTileSvc, googleAnalyticsSvc, mtzProfileSvc, loginSvc, loadLanguage) {
    $scope.languagePreference = sessionStorage.languagePreference;

    loginSvc.getJSONFileData().then(({ data }) => {

      if (sessionStorage.languagePreference.toLowerCase() === 'en') {
        // Revenue share tile image EN
        $scope.logoAsset =  data.osrscaRevShareTileImage.enUrl;
      }
      else if (sessionStorage.languagePreference.toLowerCase() === 'fr') {
        // Revenue share tile image FR
        $scope.logoAsset =  data.osrscaRevShareTileImage.frUrl;
      }
         
    }).catch((err) => {
      console.log('Oops, error getting getJSONFileData' + err);
    });
  
  $scope.goRevShare = (function(view) {
    $scope.program = $rootScope.program;
    if (!$rootScope.program) {
      $scope.program = [];
      $scope.program.name = "GM Canada Rev Share";
      $scope.program.securityTarget = [];
      $scope.program.securityTarget.securityTargetType = "Program";
      $scope.program.securityTarget.id = 2704;
      $scope.program.code = "";
      $scope.program.roles = [];
      $scope.program.roles[0] = "VIEWER";
      $scope.program.roles[1] = "OWNER";
      $scope.program.roles[2] = "GIVER";
      $scope.program.administrator = false;
      $scope.program.view = 'program';
      $rootScope.program = $scope.program;
    }
    $rootScope.program = $scope.program;
    if (view) {
      $scope.program.view = view;
    } else {
      $scope.program.view = 'program';
    }
    var action = '';
    if ($scope.program.view === 'program') {
      action = 'Reports Button Clicked';
    } else if ($scope.program.view === 'tools') {
      action = 'Tools Button Clicked';
    }
    var eventAction = $scope.program.name + ' ' + action;
    var eventParameters = {
      'event_category': 'Tile Click',
      'event_label': 'Tile Clicked'
    };
    googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    $state.go('dealer-revenue-share', {'view': $scope.program.view});
  });
  var frenchMonths = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  $scope.showspinner = true;
  mtzProfileSvc.getCompaniesWorkFor('participants/~/employment').then((function(companiesResult) {
    $scope.companyDTO = companiesResult.data;
    for (var i = 0; i < $scope.companyDTO.length; i++) {
      for(var j = 0; j < $scope.companyDTO[i].roles.length; j++) {
        if ($scope.companyDTO[i].roles[j].preferred === true) {
          $scope.preferredCompany = $scope.companyDTO[i].companyName;
          sessionStorage.bac = $scope.companyDTO[i].identifier.substring(4, 10);
          $scope.bac = sessionStorage.bac;
          $scope.getTileMetrics();
          break;
        }
      }
      break;
    }
  }));
  $scope.getTileMetrics = (function() {
    loadLanguage();
    if (sessionStorage.bac && sessionStorage.bac !== '') {
      dealerRevenueShareTileSvc.tileMetrics().then((function(res) {
        var $__0,
            $__1,
            $__2;

        (($__0 = res, ($__1 = $__0.data, ($__2 = $__1.items, $scope.metrics = $__2[0], $__2), $__1), $__0)); // jshint ignore:line
        if (sessionStorage.languagePreference !== 'en') {
          var previousMonthYear = $scope.metrics.previousMonthName.split(" ");
          var previousMonth = previousMonthYear[0];
          var previousYear = previousMonthYear[1];
          switch (previousMonth) {
            case "January":
              previousMonth = frenchMonths[0];
              break;
            case "February":
              previousMonth = frenchMonths[1];
              break;
            case "March":
              previousMonth = frenchMonths[2];
              break;
            case "April":
              previousMonth = frenchMonths[3];
              break;
            case "May":
              previousMonth = frenchMonths[4];
              break;
            case "June":
              previousMonth = frenchMonths[5];
              break;
            case "July":
              previousMonth = frenchMonths[6];
              break;
            case "August":
              previousMonth = frenchMonths[7];
              break;
            case "September":
              previousMonth = frenchMonths[8];
              break;
            case "October":
              previousMonth = frenchMonths[9];
              break;
            case "November":
              previousMonth = frenchMonths[10];
              break;
            case "December":
              previousMonth = frenchMonths[11];
              break;
          }
          $scope.metrics.previousMonthName = previousMonth + " " + previousYear;
          var currentMonthYear = $scope.metrics.currentMonthName.split(" ");
          var currentMonth = currentMonthYear[0];
          var currentYear = currentMonthYear[1];
          switch (currentMonth) {
            case "January":
              currentMonth = frenchMonths[0];
              break;
            case "February":
              currentMonth = frenchMonths[1];
              break;
            case "March":
              currentMonth = frenchMonths[2];
              break;
            case "April":
              currentMonth = frenchMonths[3];
              break;
            case "May":
              currentMonth = frenchMonths[4];
              break;
            case "June":
              currentMonth = frenchMonths[5];
              break;
            case "July":
              currentMonth = frenchMonths[6];
              break;
            case "August":
              currentMonth = frenchMonths[7];
              break;
            case "September":
              currentMonth = frenchMonths[8];
              break;
            case "October":
              currentMonth = frenchMonths[9];
              break;
            case "November":
              currentMonth = frenchMonths[10];
              break;
            case "December":
              currentMonth = frenchMonths[11];
              break;
          }
          $scope.metrics.currentMonthName = currentMonth + " " + currentYear;
        }
        $scope.showspinner = false;
      }), (function() {
        console.log('error calling tileMetrics service');
      }));
    }
  });

  dealerRevenueShareTileSvc.isFullAccess().then((function(res) {
    sessionStorage.isFullAccess = res.data; // jshint ignore:line
  }), function errorCallback(res) { // jshint ignore:line
    sessionStorage.isFullAccess = "false";
  });
})]);
am.factory('dealerRevenueShareSvc', ['$http', 'rest', (function($http, rest) {
  var svc = {};
  svc.fetchBulletins = (function() {
    var urls = [(rest.getRestUrlPrefix() + "databus/dealer-revenue-share/program-message?af-elementName=WelcomeMessage&af-language=") + sessionStorage.languagePreference, (rest.getRestUrlPrefix() + "databus/dealer-revenue-share/program-message?af-elementName=Bullet1&af-language=") + sessionStorage.languagePreference, (rest.getRestUrlPrefix() + "databus/dealer-revenue-share/program-message?af-elementName=Bullet2&af-language=") + sessionStorage.languagePreference, (rest.getRestUrlPrefix() + "databus/dealer-revenue-share/program-message?af-elementName=Bullet3&af-language=") + sessionStorage.languagePreference];
    return rest.batchGetRequests(urls);
  });
  svc.getFileUrl = (function(programId, type) {
    return '/gm-ep/rest/file/program/' + programId + '/type/' + type;
  });
  svc.authTokenDashboard = (function() {
    var url = rest.getRestUrlPrefix() + "reports/getAccessTokenForDashboard/";
    return $http.get(url);
  });
  svc.authTokenCalculate = (function() {
    var url = rest.getRestUrlPrefix() + "reports/getAccessTokenForCalculator";
    return $http.get(url);
  });
  return svc;
})]);
am.controller('dealerRevenueShareCtrl', ['$scope', '$rootScope', 'dealerRevenueShareSvc', 'googleAnalyticsSvc', '$state', '$window', 'dialogSvc', 'L10nFilter', 'loginSvc', (function($scope, $rootScope, dealerRevenueShareSvc, googleAnalyticsSvc, $state, $window, dialogSvc, l10nFilter, loginSvc) {
  angular.element(document).ready(function() {
    $scope.urlWithoutHost = window.location.href.toString().split(window.location.host)[1];
    $scope.getLastWord = $scope.urlWithoutHost.split('/')[$scope.urlWithoutHost.split('/').length - 1];
    $scope.viewFromURL = $scope.getLastWord;
    var browser = navigator.userAgent.toLowerCase();
    if ((browser.indexOf('edge') > 0 || browser.indexOf('msie') > 0 || browser.indexOf('.net') > 0 || browser.indexOf('firefox') > 0) && (sessionStorage.browserChecked === undefined)) {
      sessionStorage.browserChecked = true;
      dialogSvc.showMessage(l10nFilter('update-browser', null, true), l10nFilter('not-chrome-browser', null, true));
    } else {
      sessionStorage.browserChecked = true;
    }
    if (!$rootScope.program) {
      $scope.program = [];
      $scope.program.name = "GM Canada Rev Share";
      $scope.program.securityTarget = [];
      $scope.program.securityTarget.securityTargetType = "Program";
      $scope.program.securityTarget.id = 2704;
      $scope.program.code = "";
      $scope.program.roles = [];
      $scope.program.roles[0] = "VIEWER";
      $scope.program.roles[1] = "OWNER";
      $scope.program.roles[2] = "GIVER";
      $scope.program.administrator = false;
      $scope.program.view = 'program';
      $rootScope.program = $scope.program;
    } else {
      $scope.program = $rootScope.program;
    }
    $scope.languagePreference = sessionStorage.languagePreference;

    loginSvc.getJSONFileData().then(({ data }) => {

      if (sessionStorage.languagePreference.toLowerCase() === 'en') {
        // Dealer rev share assets English
        $scope.reportLoaderImage = data.osrscaRevenueShareImagesEn.rptLoaderUrl;
        $scope.drsLogo = data.osrscaRevenueShareImagesEn.revenueShareTileImageUrl;
        $scope.programGuideLink = data.osrscaRevenueShareImagesEn.programGuideUrl;
        $scope.getStartedGuideLink = data.osrscaRevenueShareImagesEn.howToGetStartedUrl;
        $scope.contactUsLink = data.osrscaRevenueShareImagesEn.contactHqUrl;
        $scope.payoutScheduleLink = data.osrscaRevenueShareImagesEn.payoutScheduleLink;
        $scope.faqLink = data.osrscaRevenueShareImagesEn.englishFAQs;
        $scope.bulletinMessage = data.dealerRevShareBulletinMessageQuestionEn;
        $scope.getProgramRulesDoc = data.osrscaRevenueShareImagesEn.getProgramRulesDoc;
      }
      else if (sessionStorage.languagePreference.toLowerCase() === 'fr') {
        // Dealer rev share assets French
        $scope.reportLoaderImage = data.osrscaRevenueShareImagesFr.rptLoaderUrl;
        $scope.drsLogo = data.osrscaRevenueShareImagesFr.revenueShareTileImageUrl;
        $scope.programGuideLink = data.osrscaRevenueShareImagesFr.programGuideUrl;
        $scope.getStartedGuideLink = data.osrscaRevenueShareImagesFr.howToGetStartedUrl;
        $scope.contactUsLink = data.osrscaRevenueShareImagesFr.contactHqUrl;
        $scope.payoutScheduleLink = data.osrscaRevenueShareImagesFr.payoutScheduleLink;
        $scope.faqLink = data.osrscaRevenueShareImagesFr.frenchFAQs;
        $scope.bulletinMessage = data.dealerRevShareBulletinMessageQuestionFr;
        $scope.getProgramRulesDoc = data.osrscaRevenueShareImagesFr.getProgramRulesDoc;
      }

    }).catch((err) => {
      console.log('Oops, error getting getJSONFileData' + err);
    });

    $scope.putAdditonalContent = function(index,content) {
      if(content !== undefined) {
        document.getElementById("additionalContent"+index).innerHTML = content;
      }
    };
    $scope.video = (function(id) {
      var eventAction = '';
      var eventParameters = [];
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      switch (id) {
        case "video1":
          $scope.showVideo = true;
          eventAction = 'Dealer Revenue Share Video Clicked';
          eventParameters = {
            'event_category': 'Button Click',
            'event_label': 'Dealer Revenue Share Program Launch Video Clicked'
          };
          break;
        case "video1":
          $scope.showVideo = true;
          eventAction = 'Dealer Revenue Share Video Clicked';
          eventParameters = {
            'event_category': 'Button Click',
            'event_label': 'Dealer Revenue Share Program Launch Video Clicked'
          };
          break;
      }
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.faq = (function() {
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      var eventAction = 'Dealer Revenue Share FAQ Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share FAQ Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.contact = (function() {
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      var eventAction = 'Dealer Revenue Share Contact Us Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share Contact Us Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.payCal = (function() {
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      var eventAction = 'Dealer Revenue Share Payment Calendar Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share Payment Calendar Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.programguide = (function() {
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      var eventAction = 'Dealer Revenue Share Program Guide Button Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share Program Guide Button Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.howtogetstarted = (function() {
      $scope.showVideo = false;
      $scope.showContact = false;
      $scope.showPayCal = false;
      var eventAction = 'Dealer Revenue Share How To Get Started Button Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share How To Get Started Button Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.programRules = (function() {
      var eventAction = 'Dealer Revenue Share Program Rules Clicked';
      var eventParameters = {
        'event_category': 'Button Click',
        'event_label': 'Dealer Revenue Share Program Rules Clicked'
      };
      googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    });
    $scope.program = [];
    $scope.program.view = $scope.viewFromURL;
    $scope.switchView = (function(view) {
      if (view === 'program') {
        var eventAction = 'Dealer Revenue Share Report Button Clicked';
        var eventParameters = {
          'event_category': 'Button Click',
          'event_label': 'Dealer Revenue Share Program Rules Clicked'
        };
        googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
      } else if (view === 'tools') {
        var eventAction$__4 = 'Dealer Revenue Share Tools Button Clicked';
        var eventParameters$__5 = {
          'event_category': 'Button Click',
          'event_label': 'Dealer Revenue Share Program Rules Clicked'
        };
        googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction$__4, eventParameters$__5);
      }
      $state.go('dealer-revenue-share', {'view': view}, {
        reload: true,
        notify: false
      });
      setTimeout(function() {
        $window.location.reload();
      }, 200);
    });
  });
})]);
am.controller('dealerRevenueSharePowerBiCtrl', ['$http', '$scope', 'rest', 'dealerRevenueShareSvc', '$location', 'googleAnalyticsSvc', 'PowerBiService', 'dialogSvc', 'L10nFilter', 'loginSvc', (function($http, $scope, rest, dealerRevenueShareSvc, $location, googleAnalyticsSvc, PowerBiService, dialogSvc, L10nFilter, loginSvc) {
  $scope.$on("$destroy", function() {
    document.querySelector('body').removeAttribute("style");
  });
  var pageStartTime = Date.now();
  var reportLoaded = null;
  var timeDiff = 0;
  var eventParameters;
  var title=null;
  $scope.report = '';
  $scope.reports = [];
  $scope.embedfilterUrl = '';
  $scope.embedConfig = '';
  $scope.activeFilter1 = '';
  $scope.filterTable = '';
  $scope.filterTableField = '';
  $scope.filterValue = '';
  $scope.filterTable2 = '';
  $scope.filterTableField2 = '';
  $scope.filterValue2 = '';
  $scope.usrlanguage = sessionStorage.languagePreference;
  $scope.expireOn = '';
  $scope.reportBookMarks = '';
  $scope.bookMarkState = '';
  $scope.identity1Cloumn = '';
  $scope.identity1Table = '';
  $scope.identity2Column = '';
  $scope.identity2Table = '';
  $scope.identity1Equals = '';
  $scope.identity2Equals = '';
  $scope.preOwned = '';
  $scope.preOwned1 = '';
  $scope.isfromKPI = false;
  $scope.isforReport_2 = true;
  $scope.isfromEarningsDetailButton = false;
  $scope.step3Month = '';
  $scope.step3Quarter = '';
  $scope.step3Year = '';
  var step3Month = '';
  var step3Quarter = '';
  var step3Year = '';
  var isdone=false;
  $scope.getLatest_QRTR_FRVAL = '';
  $scope.getLatest_QRTR_FRVAL2 = '';
  $scope.fromCalculator=false;
  var today = new Date();
  $scope.vindetailMonth = "";
  $scope.vindetailQuarter = "";
  $scope.vindetailYear = "";
  $scope.consultantMonth = "";
  $scope.consultantQuarter = "";
  $scope.consultantYear = "";
  $scope.visualID = '';
  $scope.printTableData = '';
  $scope.tableDataArray = [];
  $scope.internalTableDataArray = [];
  $scope.tableDataArray2 = [];
  $scope.internalTableDataArray2 = [];
  $scope.qaulifiedArray = [];
  $scope.newVehicleArray = [];
  $scope.preOwnedVehicle = [];
  $scope.serviceLaneVehicle = [];
  $scope.monthYr = [];
  $scope.qaulifiedSign = [];
  $scope.earningsDetatilVehicles = "0";
  $scope.earningsDetatilAvg = "$0.0";
  $scope.earningsDetatilEarnings = "$0";
  $scope.consultVis1 = "";
  $scope.consultVis2 = "";
  $scope.fromconsult1Selected = false;
  $scope.consult1SelectedValue = "";
  $scope.resetVisual = "";
  $scope.resetVisual2 = "";
  $scope.resetQaurterVisual = "";
  $scope.fromyr_slicer = false;
  $scope.printTitle = "";
  $scope.newVehicleEarngvalue2 = "";
  $scope.preOwnedEarngvalue2 = "";
  $scope.serviceLaneEarngvalue2 = "";
  $scope.newVehicleEarngvalue4 = "";
  $scope.preOwnedEarngvalue4 = "";
  $scope.serviceLaneEarngvalue4 = "";
  // $scope.US_loader = null;
  // $scope.CA_loader = null;
  $scope.report_element = null;
  $scope.notToStep1=false;
  $scope.keyHandler = '';
  var month_names = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
  var month = month_names[today.getMonth()];
  var year = today.getFullYear();
  var quarter = Math.floor((today.getMonth() + 3) / 3);
  quarter = "Q" + quarter;
  var filter_year = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM_YR"
    },
    operator: "In",
    values: ["" + year]
  };
  var filter_quarter = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM_QUARTER"
    },
    operator: "In",
    values: [quarter]
  };
  var filter_month = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM_MONTH"
    },
    operator: "In",
    values: [month]
  };
  var today_FR = new Date();
  var month_names_FR = ['JANV', 'FÉVR', 'MARS', 'AVRIL', 'MAI', 'JUIN', 'JUILL', 'AOÛT', 'SEPT', 'OCT', 'NOV', 'DÉC'];
  var month_FR = month_names_FR[today_FR.getMonth()];
  var year_FR = today_FR.getFullYear();
  var quarter_FR = Math.floor((today_FR.getMonth() + 3) / 3);
  quarter_FR = "T" + quarter_FR;
  var filter_year_FR = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM_YR"
    },
    operator: "In",
    values: ["" + year_FR]
  };
  var filter_quarter_FR = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM_QUARTER_CA"
    },
    operator: "In",
    values: [quarter_FR]
  };
  var filter_month_FR = {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "VW_GM_SALES_CALENDAR",
      column: "GM-MONTH_CA"
    },
    operator: "In",
    values: [month_FR]
  };
  submit();
  $scope.onEmbedded = function(report) {
    report.on('loaded', function() {
      if (sessionStorage.isFullAccess === 'true' && !($scope.fromCalculator)) {
        $scope.setActivepage(report,4);
      }else if(sessionStorage.isFullAccess === 'false')
      {
         $scope.setActivepage(report,8);
      }else {
       report.getPages().then(function(pages) {
          pages[7].setActive().then(function() {
         $scope.notToStep1=true;
          }).catch(function(errors) {
            console.log(errors);
          });
        }).catch(function(errors) {
          console.log(errors);
        });
      }

      report.on('pageChanged', ({ detail }) => onReportRendered(detail.newPage));

      function onReportRendered(page) {
           // var page = event.detail.newPage;
          var pagePath = $location.path();
          var pageTitle = page.displayName;
          googleAnalyticsSvc.callGoogleAnalytics('pageview', pagePath, pageTitle, '', '');
          timeDiff = 0;
          var eventAction =null;
          isdone=false;

          if(!isdone){
            $scope.hideVisualHeader(report,null,null);
            if (page.displayName === "Historical_Overview") {
                 page.getVisuals().then(function(visuals) {
                   var slicer_hv = visuals.find(function(visual) {
                     return visual.name === "490894ab2da7f4d9665f";
                   });
                   slicer_hv.setSlicerState({filters: [filter_year]}).catch(function(errors) {
                     console.log(errors);
                   });
                    if($scope.usrlanguage === "en")
                    {
                     eventAction ='ENGLISH Powerbi Historical Overview report load time';
                    }else {
                     eventAction ='FRENCH Powerbi Historical Overview report load time';
                    }
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
                   $scope.hideVisualHeader(report,"674280155b92d03a1e44",null);
                 }).catch(function(errors) {
                   console.log(errors);
                 });
            } else if (page.displayName === "VIN_DETAIL TOOL") {
               if ($scope.usrlanguage === "en") {
                 page.getVisuals().then(function(visuals) {
                   var slicer_vdt_y = visuals.find(function(visual) {
                     return visual.name === "9acedb0ebea598011fb6";
                   });
                   slicer_vdt_y.setSlicerState({filters: [filter_year]}).catch(function(errors) {
                     console.log(errors);
                   });
                   var slicer_vdt_q = visuals.find(function(visual) {
                     return visual.name === "6757fa80397702e432d0";
                   });
                   slicer_vdt_q.setSlicerState({filters: [filter_quarter]}).catch(function(errors) {
                     console.log(errors);
                   });
                   var slicer_vdt_m = visuals.find(function(visual) {
                     return visual.name === "e80c553bd6c3d5703697";
                   });
                   slicer_vdt_m.setSlicerState({filters: [filter_month]}).catch(function(errors) {
                     console.log(errors);
                   });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi VIN DETAIL TOOL report load time');
                   $scope.hideVisualHeader(report,"fc0e82b5f50a7e42bbdb",null);
                 }).catch(function(errors) {
                   console.log(errors);
                 });
               } else {
                 page.getVisuals().then(function(visuals) {
                   var slicer_vdt_y = visuals.find(function(visual) {
                     return visual.name === "9acedb0ebea598011fb6";
                   });
                   slicer_vdt_y.setSlicerState({filters: [filter_year_FR]}).catch(function(errors) {
                     console.log(errors);
                   });
                   var slicer_vdt_q = visuals.find(function(visual) {
                     return visual.name === "6757fa80397702e432d0";
                   });
                   slicer_vdt_q.setSlicerState({filters: [filter_quarter_FR]}).catch(function(errors) {
                     console.log(errors);
                   });
                   var slicer_vdt_m = visuals.find(function(visual) {
                     return visual.name === "e80c553bd6c3d5703697";
                   });
                   slicer_vdt_m.setSlicerState({filters: [filter_month_FR]}).catch(function(errors) {
                     console.log(errors);
                   });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi VIN Detail Tool report load time');
                   $scope.hideVisualHeader(report,"fc0e82b5f50a7e42bbdb",null);
                 }).catch(function(errors) {
                   console.log(errors);
                 });
               }
            }else if (page.displayName === "Earnings_Details" && $scope.isfromEarningsDetailButton) {
               $scope.isfromEarningsDetailButton=false;
               page.getVisuals().then(function(visuals) {
               var filter7=null;
               var slicer =null;
               if($scope.usrlanguage === "en")
               {
                    filter7 = {
                     $schema: "https://powerbi.com/product/schema#basic",
                     target: {
                       table: "VW_VEHICLE_TYPE_DIM",
                       column: "V_Type1"
                     },
                     operator: "In",
                     values: ["New Vehicle Sales"]
                   };
                    slicer = visuals.find(function(visual) {
                     return visual.name === "383856f9d73a34709181";
                   });
                   slicer.setSlicerState({filters: [filter7]}).catch(function(errors) {
                     console.log(errors);
                   });
                 }else
                 {
                     filter7 = {
                     $schema: "https://powerbi.com/product/schema#basic",
                     target: {
                       table: "VW_VEHICLE_TYPE_DIM",
                       column: "V_Type_CA"
                     },
                     operator: "In",
                     values: ["Ventes de véhicules neufs"]
                   };
                    slicer = visuals.find(function(visual) {
                     return visual.name === "383856f9d73a34709181";
                   });
                   slicer.setSlicerState({filters: [filter7]}).catch(function(errors) {
                     console.log(errors);
                   });
                 }
                if($scope.usrlanguage === "en")
                {
                 eventAction ="ENGLISH Powerbi Earnings Detail Tool report load time";
                }else {
                 eventAction ='FRENCH Powerbi Earnings Detail Tool report load time';
                }
               $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
               $scope.hideVisualHeader(report,"8f0a804b773b89db749b","fc0e82b5f50a7e42bbdb");
               }).catch(function(errors) {
                 console.log(errors);
               });
              } else if (page.displayName === "Consultant_LeaderBoard") {
               page.getVisuals().then(function(visuals) {
                 var consultVisual1 = visuals.find(function(visual) {
                   return visual.name === "b9a30854b5dba51afb54";
                 });
                 var consultVisual2 = visuals.find(function(visual) {
                   return visual.name === "fc0e82b5f50a7e42bbdb";
                 });
                 $scope.consultVis1 = consultVisual1;
                 $scope.consultVis2 = consultVisual2;
                  if($scope.usrlanguage === "en")
                  {
                   eventAction ="ENGLISH Powerbi Consultant Leaderboard report load time";
                  }else {
                   eventAction ='FRENCH Powerbi Consultant Leaderboard report load time';
                  }
               $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
               $scope.hideVisualHeader(report,"b9a30854b5dba51afb54","fc0e82b5f50a7e42bbdb");
               }).catch(function(errors) {
                 console.log(errors);
               });
             } else if (page.displayName ==="Sales manager Step 2") {
                  var models = '';
                  var visual = '';
                   page.getVisuals().then(function(visuals) {
                   var slicer_stp_2_y;
                   var slicer_stp_2_q;
                   var slicer_stp_2_m;
                   if ($scope.usrlanguage === "en") {
                      visual = visuals.filter(function(visual) {
                       return visual.title === "Step-2-latest filemonth";
                     })[0];
                     models = window['powerbi-client'].models;
                     visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                       if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                         var step2Month = "";
                         var step2Quarter = "";
                         var step2Year = "";
                         step2Month = $scope.getLatest_MNTH(result.data);
                         step2Quarter = $scope.getLatest_QRTR(step2Month);
                         step2Year = $scope.getLatest_YR(result.data);

                         var filter_year21 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_YR"
                           },
                           operator: "In",
                           values: ["" + step2Year]
                         };
                         var filter_quarter21 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_QUARTER"
                           },
                           operator: "In",
                           values: [step2Quarter]
                         };
                         var filter_month21 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_MONTH"
                           },
                           operator: "In",
                           values: [step2Month]
                         };
                         slicer_stp_2_y = visuals.find(function(visual) {
                          return visual.title ==="Year";
                         });
                         slicer_stp_2_y.setSlicerState({filters: [filter_year21]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_stp_2_q = visuals.find(function(visual) {
                          return visual.title ==="Quarter";
                         });
                         slicer_stp_2_q.setSlicerState({filters: [filter_quarter21]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_stp_2_m = visuals.find(function(visual) {
                          return visual.title === "Month";
                         });
                         slicer_stp_2_m.setSlicerState({filters: [filter_month21]}).catch(function(errors) {
                           console.log(errors);
                         });
                       }
                     }).catch(function(errors) {
                       console.log(errors);
                     });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi Step 2 Opportunity Conversion report load time Sales manager');
                   } else {
                     visual = visuals.filter(function(visual) {
                       return visual.title === "Step2";
                     })[0];
                     models = window['powerbi-client'].models;
                     visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                       if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                         var step2Month = "";
                         var step2Quarter = "";
                         var step2Year = "";
                         $scope.getLatest_QRTR_FRVAL = "";
                         step2Month = $scope.getLatest_MNTH_FR2(result.data);
                         step2Quarter = $scope.getLatest_QRTR_FRVAL2;
                         step2Year = $scope.getLatest_YR_FR2(result.data);

                         var filter_year_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_YR"
                           },
                           operator: "In",
                           values: ["" + step2Year]
                         };
                         var filter_quarter_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_QUARTER_CA"
                           },
                           operator: "In",
                           values: [step2Quarter]
                         };
                         var filter_month_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM-MONTH_CA"
                           },
                           operator: "In",
                           values: [step2Month]
                         };
                         slicer_stp_2_y = visuals.find(function(visual) {
                           return visual.title ==="Année";
                         });
                         slicer_stp_2_y.setSlicerState({filters: [filter_year_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_stp_2_q = visuals.find(function(visual) {
                           return visual.title==="Trimestre";
                         });
                         slicer_stp_2_q.setSlicerState({filters: [filter_quarter_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_stp_2_m = visuals.find(function(visual) {
                           return visual.title === "Mois";
                         });
                         slicer_stp_2_m.setSlicerState({filters: [filter_month_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                       }
                     }).catch(function(errors) {
                       console.log(errors);
                     });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi Step 2 Opportunity Conversion report load time Sales manager');
                   }
               }).catch(function(errors) {
                 console.log(errors);
               });
           }else if((page.displayName ==="Step 1" || page.displayName ==="Sales manager Step 1") && (!($scope.fromCalculator)) && (!($scope.notToStep1))){
                //  if ($scope.usrlanguage === 'en') {
                //        $scope.US_loader.style.display = 'none';
                //      } else {
                //        $scope.CA_loader.style.display = 'none';
                //      }
                     $scope.report_element.style.visibility = 'visible';
                     if($scope.usrlanguage === "en")
                      {
                          if(page.displayName ==="Sales manager Step 1")
                          {
                            eventAction ='ENGLISH Powerbi Step 1 Qualifications report load time Sales manager';
                          }else
                          {
                            eventAction ='ENGLISH Powerbi Step 1 Qualifications report load time';
                          }
                      }else {
                       if(page.displayName ==="Sales manager Step 1")
                          {
                            eventAction ='FRENCH Powerbi Step 1 Qualifications report load time Sales manager';
                          }else
                          {
                            eventAction ='FRENCH Powerbi Step 1 Qualifications report load time';
                          }
                      }
                     $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
            }else if(page.displayName ==="Step 2"){
                  page.getVisuals().then(function(visuals) {
                  var slicer_stp_2_y;
                  var slicer_stp_2_q;
                  var slicer_stp_2_m;
                  if ($scope.usrlanguage === "en") {
                    visual = visuals.filter(function(visual) {
                      return visual.title === "Step-2-latest filemonth";
                    })[0];
                    models = window['powerbi-client'].models;
                    visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                      if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                        var step2Month = "";
                        var step2Quarter = "";
                        var step2Year = "";
                        step2Month = $scope.getLatest_MNTH(result.data);
                        step2Quarter = $scope.getLatest_QRTR(step2Month);
                        step2Year = $scope.getLatest_YR(result.data);

                        var filter_year21 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM_YR"
                          },
                          operator: "In",
                          values: ["" + step2Year]
                        };
                        var filter_quarter21 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM_QUARTER"
                          },
                          operator: "In",
                          values: [step2Quarter]
                        };
                        var filter_month21 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM_MONTH"
                          },
                          operator: "In",
                          values: [step2Month]
                        };
                        slicer_stp_2_y = visuals.find(function(visual) {
                          return visual.name === "885fb2415294b24eaa3c";
                        });
                        slicer_stp_2_y.setSlicerState({filters: [filter_year21]}).catch(function(errors) {
                          console.log(errors);
                        });
                        slicer_stp_2_q = visuals.find(function(visual) {
                          return visual.name === "4b4b40f0c842cec171ca";
                        });
                        slicer_stp_2_q.setSlicerState({filters: [filter_quarter21]}).catch(function(errors) {
                          console.log(errors);
                        });
                        slicer_stp_2_m = visuals.find(function(visual) {
                          return visual.name === "178709715b9e38290382";
                        });
                        slicer_stp_2_m.setSlicerState({filters: [filter_month21]}).catch(function(errors) {
                          console.log(errors);
                        });
                      }
                    }).catch(function(errors) {
                      console.log(errors);
                    });
                    $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi Step 2 Opportunity Conversion report load time');
                  } else {
                    visual = visuals.filter(function(visual) {
                      return visual.title === "Step2";
                    })[0];
                    models = window['powerbi-client'].models;
                    visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                      if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                        var step2Month = "";
                        var step2Quarter = "";
                        var step2Year = "";
                        $scope.getLatest_QRTR_FRVAL = "";
                        step2Month = $scope.getLatest_MNTH_FR2(result.data);
                        step2Quarter = $scope.getLatest_QRTR_FRVAL2;
                        step2Year = $scope.getLatest_YR_FR2(result.data);

                        var filter_year_FR22 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM_YR"
                          },
                          operator: "In",
                          values: ["" + step2Year]
                        };
                        var filter_quarter_FR22 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM_QUARTER_CA"
                          },
                          operator: "In",
                          values: [step2Quarter]
                        };
                        var filter_month_FR22 = {
                          $schema: "http://powerbi.com/product/schema#basic",
                          target: {
                            table: "VW_GM_SALES_CALENDAR",
                            column: "GM-MONTH_CA"
                          },
                          operator: "In",
                          values: [step2Month]
                        };
                        slicer_stp_2_y = visuals.find(function(visual) {
                          return visual.name === "885fb2415294b24eaa3c";
                        });
                        slicer_stp_2_y.setSlicerState({filters: [filter_year_FR22]}).catch(function(errors) {
                          console.log(errors);
                        });
                        slicer_stp_2_q = visuals.find(function(visual) {
                          return visual.name === "4b4b40f0c842cec171ca";
                        });
                        slicer_stp_2_q.setSlicerState({filters: [filter_quarter_FR22]}).catch(function(errors) {
                          console.log(errors);
                        });
                        slicer_stp_2_m = visuals.find(function(visual) {
                          return visual.name === "178709715b9e38290382";
                        });
                        slicer_stp_2_m.setSlicerState({filters: [filter_month_FR22]}).catch(function(errors) {
                          console.log(errors);
                        });
                      }
                    }).catch(function(errors) {
                      console.log(errors);
                    });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi Step 2 Opportunity Conversion report load time');
                  }
                  }).catch(function(errors) {
                    console.log(errors);
                  });
             }else if(page.displayName ==="Step 3"){
                 page.getVisuals().then(function(visuals) {
                 var models = '';
                 var visual = '';
                 if ($scope.usrlanguage === "en") {
                   visual = visuals.find(function(visual) {
                     return visual.name === "dfb37b1ff05d3c95ce32";
                   });
                   models = window['powerbi-client'].models;
                   visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                     if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                       step3Month = "";
                       step3Quarter = "";
                       step3Year = "";
                       step3Month = $scope.getLatest_MNTH(result.data);
                       step3Quarter = $scope.getLatest_QRTR(step3Month);
                       step3Year = $scope.getLatest_YR(result.data);
                       var filter_year_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "YR"
                         },
                         operator: "In",
                         values: ["" + step3Year]
                       };
                       var filter_quarter_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "QuarterName"
                         },
                         operator: "In",
                         values: [step3Quarter]
                       };
                       var filter_month_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "MO"
                         },
                         operator: "In",
                         values: [step3Month]
                       };
                       var slicer1 = visuals.find(function(visual) {
                       return visual.name==="10b0c740168b47bd1854";
                       });
                       slicer1.setSlicerState({filters: [filter_year_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                       var slicer2 = visuals.find(function(visual) {
                         return visual.title === "Quarter";
                       });
                       slicer2.setSlicerState({filters: [filter_quarter_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                       var slicer3 = visuals.find(function(visual) {
                         return visual.title === "Month";
                       });
                       slicer3.setSlicerState({filters: [filter_month_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                     }
                   }).catch(function(errors) {
                     console.log(errors);
                   });
                    $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi Step 3 Earnings Review report load time');
                 } else {
                   visual = visuals.find(function(visual) {
                     return visual.title === "Step3-Latestmonth";
                   });
                   models = window['powerbi-client'].models;
                   visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                     if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                       step3Month = "";
                       step3Quarter = "";
                       step3Year = "";
                       $scope.getLatest_QRTR_FRVAL = "";
                       step3Month = $scope.getLatest_MNTH_FR(result.data);
                       step3Quarter = $scope.getLatest_QRTR_FRVAL;
                       step3Year = $scope.getLatest_YR_FR(result.data);
                       var filter_year_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "YR"
                         },
                         operator: "In",
                         values: ["" + step3Year]
                       };
                       var filter_quarter_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "QuarterName"
                         },
                         operator: "In",
                         values: [step3Quarter]
                       };
                       var filter_month_step_3 = {
                         $schema: "https://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_CALENDAR_DIM",
                           column: "MO_FRENCH_SHORT_FORM"
                         },
                         operator: "In",
                         values: [step3Month]
                       };
                       var slicer1 = visuals.find(function(visual) {
                         return visual.title ==="Année";
                       });
                       slicer1.setSlicerState({filters: [filter_year_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                       var slicer2 = visuals.find(function(visual) {
                        return visual.title ==="Trimestre";
                       });
                       slicer2.setSlicerState({filters: [filter_quarter_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                       var slicer3 = visuals.find(function(visual) {
                          return visual.title === "Mois";
                       });
                       slicer3.setSlicerState({filters: [filter_month_step_3]}).catch(function(errors) {
                         console.log(errors);
                       });
                     }
                   }).catch(function(errors) {
                     console.log(errors);
                   });
                      $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi Step 3 Earnings Review report load time');
                 }
                 }).catch(function(errors) {
                   console.log(errors);
                 });
              }else if(page.displayName==="Step 4"){
                  $scope.fromCalculator=false;
                //  if ($scope.usrlanguage === 'en') {
                //    $scope.US_loader.style.display = 'none';
                //  } else {
                //    $scope.CA_loader.style.display = 'none';
                //  }
                 $scope.report_element.style.visibility = 'visible';
                 if($scope.usrlanguage === "en")
                    {
                     eventAction ='ENGLISH Powerbi Step 4 Earnings Potential report load time';
                    }else {
                     eventAction ='FRENCH Powerbi Step 4 Earnings Potential report load time';
                    }
                 $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
                 } else if (page.displayName ==="MYP Payout Report") {
                   page.getVisuals().then(function(visuals) {
                   var slicer_mypr_y;
                   var slicer_mypr_q;
                   var slicer_mypr_m;
                   if ($scope.usrlanguage === "en") {
                      visual = visuals.filter(function(visual) {
                       return visual.title === "MYP-LastYrMo";
                     })[0];
                     models = window['powerbi-client'].models;
                     visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                       if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                         var mypMonth = "";
                         var mypQuarter = "";
                         var mypYear = "";
                         mypMonth = $scope.getLatest_MNTH(result.data);
                         mypQuarter = $scope.getLatest_QRTR(mypMonth);
                         mypYear = $scope.getLatest_YR(result.data);

                         var filter_mypYear = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_YR"
                           },
                           operator: "In",
                           values: ["" + mypYear]
                         };
                         var filter_mypQuarter = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_QUARTER"
                           },
                           operator: "In",
                           values: [mypQuarter]
                         };
                         var filter_mypMonth = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_MONTH"
                           },
                           operator: "In",
                           values: [mypMonth]
                         };
                         slicer_mypr_y = visuals.find(function(visual) {
                          return visual.title ==="YR-MYP";
                         });
                         slicer_mypr_y.setSlicerState({filters: [filter_mypYear]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_mypr_q = visuals.find(function(visual) {
                          return visual.title ==="QUARTER-MYP";
                         });
                         slicer_mypr_q.setSlicerState({filters: [filter_mypQuarter]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_mypr_m = visuals.find(function(visual) {
                          return visual.title === "MO-MYP";
                         });
                         slicer_mypr_m.setSlicerState({filters: [filter_mypMonth]}).catch(function(errors) {
                           console.log(errors);
                         });
                       }
                     }).catch(function(errors) {
                       console.log(errors);
                     });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi Step 4 MYP Payout report load time Sales manager');
                   } else {
                     visual = visuals.filter(function(visual) {
                       return visual.title === "MYP-LastYrMo";
                     })[0];
                     models = window['powerbi-client'].models;
                     visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                       if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                         var mypMonth = "";
                         var mypQuarter = "";
                         var mypYear = "";
                         $scope.getLatest_QRTR_FRVAL = "";
                         mypMonth = $scope.getLatest_MNTH_FR2(result.data);
                         mypQuarter = $scope.getLatest_QRTR_FRVAL2;
                         mypYear = $scope.getLatest_YR_FR2(result.data);

                         var filter_year_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_YR"
                           },
                           operator: "In",
                           values: ["" + mypYear]
                         };
                         var filter_quarter_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM_QUARTER_CA"
                           },
                           operator: "In",
                           values: [mypQuarter]
                         };
                         var filter_month_FR22 = {
                           $schema: "http://powerbi.com/product/schema#basic",
                           target: {
                             table: "VW_GM_SALES_CALENDAR",
                             column: "GM-MONTH_CA"
                           },
                           operator: "In",
                           values: [mypMonth]
                         };
                         slicer_mypr_y = visuals.find(function(visual) {
                           return visual.title ==="YR-MYP";
                         });
                         slicer_mypr_y.setSlicerState({filters: [filter_year_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_mypr_q = visuals.find(function(visual) {
                           return visual.title==="QUARTER-MYP";
                         });
                         slicer_mypr_q.setSlicerState({filters: [filter_quarter_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                         slicer_mypr_m = visuals.find(function(visual) {
                           return visual.title === "MO-MYP";
                         });
                         slicer_mypr_m.setSlicerState({filters: [filter_month_FR22]}).catch(function(errors) {
                           console.log(errors);
                         });
                       }
                     }).catch(function(errors) {
                       console.log(errors);
                     });
                   $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi Step 4 MYP Payout report load time Sales manager');
                   }
               }).catch(function(errors) {
                 console.log(errors);
               });
              } else if (page.displayName ==="PreOwned Payout Report") {
                 page.getVisuals().then(function(visuals) {
                 var slicer_ppr_y;
                 var slicer_mypr_q;
                 var slicer_mypr_m;
                 if ($scope.usrlanguage === "en") {
                    visual = visuals.filter(function(visual) {
                     return visual.title === "PreOwned-LastYrMo";
                   })[0];
                   models = window['powerbi-client'].models;
                   visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                     if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                       var preOwnedMonth = "";
                       var preOwnedQuarter = "";
                       var preOwnedYear = "";
                       preOwnedMonth = $scope.getLatest_MNTH(result.data);
                       preOwnedQuarter = $scope.getLatest_QRTR(preOwnedMonth);
                       preOwnedYear = $scope.getLatest_YR(result.data);

                       var filter_preOwnedYear = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM_YR"
                         },
                         operator: "In",
                         values: ["" + preOwnedYear]
                       };
                       var filter_preOwnedQuarter = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM_QUARTER"
                         },
                         operator: "In",
                         values: [preOwnedQuarter]
                       };
                       var filter_preOwnedMonth = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM_MONTH"
                         },
                         operator: "In",
                         values: [preOwnedMonth]
                       };
                       slicer_ppr_y = visuals.find(function(visual) {
                        return visual.title ==="YR-MYP";
                       });
                       slicer_ppr_y.setSlicerState({filters: [filter_preOwnedYear]}).catch(function(errors) {
                         console.log(errors);
                       });
                       slicer_mypr_q = visuals.find(function(visual) {
                        return visual.title ==="QUARTER-MYP";
                       });
                       slicer_mypr_q.setSlicerState({filters: [filter_preOwnedQuarter]}).catch(function(errors) {
                         console.log(errors);
                       });
                       slicer_mypr_m = visuals.find(function(visual) {
                        return visual.title === "MO-MYP";
                       });
                       slicer_mypr_m.setSlicerState({filters: [filter_preOwnedMonth]}).catch(function(errors) {
                         console.log(errors);
                       });
                     }
                   }).catch(function(errors) {
                     console.log(errors);
                   });
                 $scope.calculateGoogleAnyalyticsTime(pageStartTime,'ENGLISH Powerbi Step 4 PreOwned report load time Sales manager');
                 } else {
                   visual = visuals.filter(function(visual) {
                     return visual.title === "PreOwned-LastYrMo";
                   })[0];
                   models = window['powerbi-client'].models;
                   visual.exportData(models.ExportDataType.Summarized).then(function(result) {
                     if (result.data.contains !== " \n" || result.data !== "BLANK" || result.data !== "blank" || result.data !== " " || result.data !== "" || result.data !== null) {
                       var preOwnedMonth = "";
                       var preOwnedQuarter = "";
                       var preOwnedYear = "";
                       $scope.getLatest_QRTR_FRVAL = "";
                       preOwnedMonth = $scope.getLatest_MNTH_FR2(result.data);
                       preOwnedQuarter = $scope.getLatest_QRTR_FRVAL2;
                       preOwnedYear = $scope.getLatest_YR_FR2(result.data);

                       var filter_year_FR22 = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM_YR"
                         },
                         operator: "In",
                         values: ["" + preOwnedYear]
                       };
                       var filter_quarter_FR22 = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM_QUARTER_CA"
                         },
                         operator: "In",
                         values: [preOwnedQuarter]
                       };
                       var filter_month_FR22 = {
                         $schema: "http://powerbi.com/product/schema#basic",
                         target: {
                           table: "VW_GM_SALES_CALENDAR",
                           column: "GM-MONTH_CA"
                         },
                         operator: "In",
                         values: [preOwnedMonth]
                       };
                       slicer_ppr_y = visuals.find(function(visual) {
                         return visual.title ==="YR-MYP";
                       });
                       slicer_ppr_y.setSlicerState({filters: [filter_year_FR22]}).catch(function(errors) {
                         console.log(errors);
                       });
                       slicer_mypr_q = visuals.find(function(visual) {
                         return visual.title==="QUARTER-MYP";
                       });
                       slicer_mypr_q.setSlicerState({filters: [filter_quarter_FR22]}).catch(function(errors) {
                         console.log(errors);
                       });
                       slicer_mypr_m = visuals.find(function(visual) {
                         return visual.title === "MO-MYP";
                       });
                       slicer_mypr_m.setSlicerState({filters: [filter_month_FR22]}).catch(function(errors) {
                         console.log(errors);
                       });
                     }
                   }).catch(function(errors) {
                     console.log(errors);
                   });
                 $scope.calculateGoogleAnyalyticsTime(pageStartTime,'FRENCH Powerbi Step 4 PreOwned report load time Sales manager');
                 }
             }).catch(function(errors) {
               console.log(errors);
             });
            }
                  isdone=true;
                   }
      }


  report.on('dataSelected', function(event) {
    pageStartTime = Date.now();
    var data = event.detail;
    if (data.visual.name === "080e83e0e80d004873d1") {
      $scope.isfromEarningsDetailButton = false;
      if (data.dataPoints[0].identity.length === 1) {
        $scope.identity1Cloumn = data.dataPoints[0].identity[0].target.column;
        $scope.identity1Table = data.dataPoints[0].identity[0].target.table;
        $scope.identity1Equals = data.dataPoints[0].identity[0].equals;
        if ($scope.identity1Equals.includes("New Vehicle")) {
          $scope.identity1Equals = "New Vehicle Sales";
        } else if ($scope.identity1Equals.includes("Pre")) {
          $scope.identity1Equals = "Pre-owned Sales";
        } else if ($scope.identity1Equals.includes("Service")) {
          $scope.identity1Equals = "Service Lane Sales";
        }
        if ($scope.identity1Equals.indexOf("New Vehicle") >= 0) {
          $scope.identity1Equals = "New Vehicle Sales";
        } else if ($scope.identity1Equals.indexOf("Pre") >= 0) {
          $scope.identity1Equals = "Pre-Owned Sales";
        } else if ($scope.identity1Equals.indexOf("Service") >= 0) {
          $scope.identity1Equals = "Service Lane Sales";
        }
        report.getPages().then(function(pages) {
          var activePage = pages.find(function(page) {
            return page.isActive;
          });
          activePage.getFilters().then(function() {
            var filter7 = {
              $schema: "https://powerbi.com/product/schema#basic",
              target: {
                table: "VW_VEHICLE_TYPE_DIM",
                column: "V_Type"
              },
              operator: "In",
              values: [$scope.identity1Equals]
            };
            report.getPages().then(function(pages) {
              pages[1].setActive().catch(function(errors) {
                console.log(errors);
              });
              setTimeout(function() {
                pages[1].getVisuals().then(function(visuals) {
                  var slicer = visuals.find(function(visual) {
                    return visual.name === "383856f9d73a34709181";
                  });
                  slicer.setSlicerState({filters: [filter7]}).catch(function(errors) {
                    console.log(errors);
                  });
                });
              }, 2000);
            }).catch(function(errors) {
              console.log(errors);
            });
          });
        }).catch(function(errors) {
          console.log(errors);
        });
        }
        } else if (data.visual.name === "195c8f0162f56b978ace" || data.visual.name === "9753224e13caf61eac02") {
          $scope.isfromEarningsDetailButton = true;
          $scope.setActivepage(report,1);
        } else if (data.visual.name === "b002253d30cd3b387560" || data.visual.name === "e094f1f7b6359fa1d2b6" || data.visual.name === "75f06d6c83770fa26079" || data.visual.name === "1c5ec34fbc5801c67a2e") {
          if (sessionStorage.isFullAccess === 'true') {
            $scope.setActivepage(report,4);
          } else {
            $scope.setActivepage(report,8);
          }
        } else if (data.visual.name === "3a3e3997989f02252c6a") {
          $scope.PrintFunction();
        } else if (data.visual.name === "0e430e0b8a7855c2f465") {
          $scope.setActivepage(report,2);
        } else if (data.visual.name === "b39c35ce4f0b8a95efbe") {
          $scope.setActivepage(report,3);
        } else if (data.visual.name === "e87fd37fb453cb110b5d") {
          $scope.setActivepage(report,0);
        } else if (data.visual.name === "cea9952ccef59907a34e" || data.visual.name === "90f0bbfb736d624d8527") {
          $scope.isforReport_2 = true;
         $scope.fromCalculator=true;
          submit();
        } else if (data.visual.name === "7ca06a2eb07dd35b48ed") {
          $scope.setActivepage(report,1);
        } else if (data.visual.name === "1209fa34460e0adb2220") {
          $scope.setActivepage(report,0);
        } else if (data.visual.name === "b9a30854b5dba51afb54") {
            $scope.fromconsult1Selected = true;
            $scope.consult1SelectedValue = data.dataPoints[0].identity[0].equals;
            setTimeout(function () {
             var models = window['powerbi-client'].models;
              $scope.consultVis1.exportData(models.ExportDataType.Summarized)
                .then(function (result) {
                  $scope.tableDataArray = [];
                  var res = result.data.split("\n");
                  var o = 0;
                  for (var i = 0; i < res.length; i++) {
                    if (res[i] !== "") {
                      var res1 = res[i].toString();
                      if (res1.length > 0) {
                        var res2 = res1.split(",");
                        $scope.tableDataArray.push(res2);
                        o = o + 1;
                      }
                    }
                  }
                })
                .catch(function (errors) {
                  console.log(errors);
                });
              $scope.consultVis2.exportData(models.ExportDataType.Summarized)
                .then(function (result) {
                  $scope.tableDataArray2 = [];
                  var res = result.data.split("\n");
                  var o = 0;
                  for (var i = 0; i < res.length; i++) {
                    if (res[i] !== "") {
                      var res1 = res[i].toString();
                      if (res1.length > 0) {
                        var res2 = res1.split(",");
                        $scope.tableDataArray2.push(res2);
                        o = o + 1;
                      }
                    }
                  }
                })
                .catch(function (errors) {
                  console.log(errors);
                });
            }, 900);
          }
      });
      report.on('buttonClicked', function(event) {
        var data = event.detail;
        pageStartTime = Date.now();
        timeDiff = 0;
        if (data.id === "0a6f8a2de4064c345c2a" || data.id === "119e74e72b2e590e44a3" || data.id === "e6aac2541c1ff7d6b312" || data.id === "5fdb87f48a1912131826" || data.id === "3d3fc6b8b3bca8aa7f67") {
          report.print();
        } else if (data.id === "9b8cf0cc48ecb7f373c0") {
          $scope.printTableData("674280155b92d03a1e44"," HISTORICAL OVERVIEW ");
        } else if (data.id === "09963777d6a25e0af4ab") {
          $scope.printTableData("fc0e82b5f50a7e42bbdb"," VIN DETAIL TOOL ");
        } else if (data.id === "a3fd7678682f4a7d3be4" || data.id === "b05ea61d4fc94d0f9963") {
          if ($scope.fromconsult1Selected) {
            $scope.fromconsult1Selected = false;
            $scope.addConsult1Table();
            $scope.addConsult2Table();
            $scope.print3Div();
          } else {
            $scope.consult1SelectedValue = "";
            $scope.fromconsult1Selected = false;
            var models = window['powerbi-client'].models;
            $scope.consultVis1.exportData(models.ExportDataType.Summarized).then(function(result) {
              $scope.tableDataArray = [];
              var res = result.data.split("\n");
              var o = 0;
              for (var i = 0; i < res.length; i++) {
                if (res[i] !== "") {
                  var res1 = res[i].toString();
                  if (res1.length > 0) {
                    var res2 = res1.split(",");
                    $scope.tableDataArray.push(res2);
                    o = o + 1;
                  }
                }
              }
              $scope.addConsult1Table();
            }).catch(function(errors) {
              console.log(errors);
            });
            $scope.consultVis2.exportData(models.ExportDataType.Summarized).then(function(result) {
              $scope.tableDataArray2 = [];
              var res = result.data.split("\n");
              var o = 0;
              for (var i = 0; i < res.length; i++) {
                if (res[i] !== "") {
                  var res1 = res[i].toString();
                  if (res1.length > 0) {
                    var res2 = res1.split(",");
                    $scope.tableDataArray2.push(res2);
                    o = o + 1;
                  }
                }
              }
              $scope.addConsult2Table();
              $scope.print3Div();
            }).catch(function(errors) {
              console.log(errors);
            });
          }
        } else if (data.id === "ac5dd3d317cb96316ee9") {
          $scope.printEarningsCombineData();
        } else if (data.id === "ff75ac45570cc9218465") {
          $scope.printTableData("674280155b92d03a1e44"," Aperçu de l'historique ");
        } else if (data.id === "f0a73cc4ce223685d672") {
          $scope.printTableData("fc0e82b5f50a7e42bbdb"," Outil de renseignements sur le NIV ");
        } else if (data.id === "676477e148680b6d6933") {
          $scope.printEarningsCombineData();
        }else if(data.title==="cal-image" || data.title==="Calculator-FR")  ///// stpe-4 to calculator
         {
           $scope.isforReport_2 = false;
           $scope.fromCalculator=true;
           submit();
         }else if(data.title ==="BACK TO PERFORMANCE DASHBOARD-VIN-FR" || data.title === "BACK TO PERFORMANCE DASHBOARD-HISTO-FR" || data.title ==="BACK TO PERFORMANCE DASHBOARD-HISTO" || data.title ==="BACK TO PERFORMANCE DASHBOARD-VIN")
         {
           if (sessionStorage.isFullAccess === 'true') {
                     $scope.setActivepage(report,4);
                      reportLoaded = Date.now();
                     timeDiff += (moment(reportLoaded).diff(moment(pageStartTime), 'milliseconds') / 1000);
               }else {
                    $scope.setActivepage(report,8);
                   reportLoaded = Date.now();
                   timeDiff += (moment(reportLoaded).diff(moment(pageStartTime), 'milliseconds') / 1000);
               }
         }else if(data.title ==="BACK TO PERFORMANCE DASHBOARD-CONSUL-FR" || data.title ==="BACK TO PERFORMANCE DASHBOARD-CONSUL"){
              if (sessionStorage.isFullAccess === 'true') {
                     $scope.setActivepage(report,5);
                       reportLoaded = Date.now();
                      timeDiff += (moment(reportLoaded).diff(moment(pageStartTime), 'milliseconds') / 1000);
               }else {
                    $scope.setActivepage(report,9);
                     reportLoaded = Date.now();
                    timeDiff += (moment(reportLoaded).diff(moment(pageStartTime), 'milliseconds') / 1000);
                 }
         }else if(data.title ==="BACK TO PERFORMANCE DASHBOARD-EARNING-FR" || data.title ==="BACK TO PERFORMANCE DASHBOARD-EARNING"){
             $scope.setActivepage(report,6);
         }else if(data.id === "78941c530b41c1a37e93" || data.id==="3e76833393b29707a9d7") ///open pdf
         {
           $scope.open_pdf();
         }else if(data.title==="Opportunity Conversion-Bookmark" || data.title==="Opportunity Conversion-Bookmark-step-4") /// step-4 to step-2
         { $scope.notToStep1=true;
         }else if(data.title==="Earnings Review-Bookmark" || data.title==="Earnings Review-Bookmark-step-4")  //step-4 to step-3
         { $scope.notToStep1=true;
         }else if(data.title==="Opportunity Conversion-Bookmark-step-3" ) //step-3 to step-2
         { $scope.notToStep1=true;
         }else if(data.title==="Earnings Potential-Bookmark" || data.title==="Earnings Potential-Bookmark-step-3") //step-3 to step-4
         {  $scope.notToStep1=true;
         }else if(data.title==="Earnings Review-Bookmark" || data.title==="Earnings Review-Bookmark-step-2") //step-2 to step-3
         {  $scope.notToStep1=true;
         }else if(data.title==="Earnings Potential-Bookmark-step-2") //step-2 to step-4
         { $scope.notToStep1=true;
         }else if(data.title==="Qaulifications-Bookmark-step-4" ) //step-4 to step-1
         {  $scope.notToStep1=false;
         }else if(data.title==="Qaulifications-Bookmark-step-2" ) //step-2 to step-1
         { $scope.notToStep1=false;
         }else if(data.title==="Qaulifications-Bookmark" || data.title==="Qaulifications-Bookmark-step-3") //step-3 to step-1
         { $scope.notToStep1=false;
         }else if(data.id==="b8b7db5e44702a33a886" || data.id==="e6a8574295a4bb933a70") //step-3 to earnings detailspage
         { $scope.isfromEarningsDetailButton = true; }
      });
    });
  };
  function setFilters() {
    var models = window['powerbi-client'].models;
    var pageSize = {
      type: models.PageSizeType.Custom,
      width: 1280,
      height: 1580
    };
    $scope.embedConfig = {settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        customLayout: {pageSize: pageSize},
        localeSettings: {
          language: $scope.usrlanguage,
          formatLocale: $scope.usrlanguage
        }
      }};
  }
  function submit() {
    // if ($scope.US_loader === null) {
    //   $scope.US_loader = document.getElementById('US_loader');
    // }
    // if ($scope.CA_loader === null) {
    //   $scope.CA_loader = document.getElementById('CA_loader');
    // }
    if ($scope.report_element === null) {
      $scope.report_element = document.getElementById('myReport');
    }
    if(sessionStorage.bac === "null" || sessionStorage.bac === null){
         dialogSvc.showMessage(L10nFilter('power-bi-report-data-error', null, true), L10nFilter('power-bi-report-missing-bac', null, true));
        //  if($scope.US_loader === null ){
        //    $scope.CA_loader.style.display='none';
        //  }else{
        //     $scope.US_loader.style.display='none';
        //  }
         return;
       }else{
       var bac_val= JSON.parse(sessionStorage.bac).toString();
       if(bac_val === null || bac_val === "null" || bac_val === " " || bac_val === ""){
       dialogSvc.showMessage(L10nFilter('power-bi-report-data-error', null, true), L10nFilter('power-bi-report-missing-bac', null, true));
        //  if($scope.US_loader === null ){
        //   $scope.CA_loader.style.display='none';
        //   }else{
        //   $scope.US_loader.style.display='none';
        //   }
         return;
     }}
    // if ($scope.usrlanguage === 'en') {
    //   $scope.US_loader.style.display = 'block';
    // } else {
    //   $scope.CA_loader.style.display = 'block';
    // }
    $scope.report_element.style.visibility = 'hidden';
     pageStartTime = Date.now();
     timeDiff = 0;
    if (!$scope.isforReport_2) {
      dealerRevenueShareSvc.authTokenCalculate().then((function($__0) {
        var data = $__0.data;
        $scope.reports = null;
        $scope.report = data ? data : null;
        $scope.report.embedUrl=$scope.report.embedUrl+"&$filter=VW_DEALER_DIM/BAC eq '"+JSON.parse(sessionStorage.bac).toString()+"' and VW_COUNTRY_DIM/COUNTRY_CODE eq 'CA'";
        var container = document.getElementById("myReport");
        powerbi.reset(container);
        $scope.reports = [];
        $scope.reports.push($scope.report);
        powerbi.init();
        $scope.isforReport_2 = false;
        $scope.filterValue = sessionStorage.bac;
        $scope.filterTable = data.filterTable;
        $scope.filterTableField = data.filterTableField;
        $scope.filterTable2 = data.filterTable2;
        $scope.filterTableField2 = data.filterTableField2;
        $scope.filterValue2 = data.filterValue2;
        setFilters(data);
        setTimeout(function() {
        var eventAction=null;
          if ($scope.usrlanguage === 'en') {
            // $scope.US_loader.style.display = 'none';
            eventAction='ENGLISH Powerbi Revenue Share Calculator load time';
          } else {
            // $scope.CA_loader.style.display = 'none';
            eventAction='FRENCH Powerbi Revenue Share Calculator load time';
          }
          $scope.report_element.style.visibility = 'visible';
          $scope.calculateGoogleAnyalyticsTime(pageStartTime,eventAction);
          var element = document.getElementById('myReport');
          var report = powerbi.get(element); // jshint ignore:line
          $scope.hideVisualHeader(report,null,null);
        }, 7000);
        $scope.expireOn = $scope.report.expireOnDate;
      }), function errorCallback(response) {
        alert("Error status" + response.data.exceptionStatus + "\n" + response.data.exceptionMessage);
      }).catch(function(errors) {
        console.log(errors);
      });
    } else {
      dealerRevenueShareSvc.authTokenDashboard().then((function($__0) {
        var data = $__0.data;
        $scope.report = data ? data : null;
        $scope.report.embedUrl=$scope.report.embedUrl+"&$filter=VW_DEALER_DIM/BAC eq '"+JSON.parse(sessionStorage.bac).toString()+"' and VW_COUNTRY_DIM/COUNTRY_CODE eq 'CA'";
        var container = document.getElementById("myReport");
        powerbi.reset(container);
        $scope.reports.pop();
        $scope.reports.push($scope.report);
        powerbi.init();
        $scope.isforReport_2 = true;
        $scope.filterValue = 222064;
        $scope.filterTable = data.filterTable;
        $scope.filterTableField = data.filterTableField;
        $scope.filterTable2 = data.filterTable2;
        $scope.filterTableField2 = data.filterTableField2;
        $scope.filterValue2 = data.filterValue2;
        setFilters();
        $scope.expireOn = $scope.report.expireOnDate;
      })).catch(function(errors) {
        if (errors.data[0].code === 'PROFILE') {
          dialogSvc.showMessage("Profile is not complete, report will not load - Le profil n'est pas complet, le rapport ne se chargera pas");
        }
        console.log(errors);
      });
    }
  }
  $scope.PrintFunction = function PrintFunction() {
    var eventAction = 'Dealer Revenue Share PowerBI Print Button Clicked';
    var eventParameters = {
      'event_category': 'PowerBI',
      'event_label': 'Dealer Revenue Share PowerBI Print Button Clicked'
    };
    googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
    var element = document.getElementById('myReport');
    var report = PowerBiService.get(element);
    report.print();
  };
  $scope.open_pdf = function open_pdf() {
    $scope.languagePreference = sessionStorage.languagePreference;
 
    loginSvc.getJSONFileData().then(({ data }) => {

      if ( $scope.languagePreference.toLowerCase() === 'en' ) {
        // Dealer rev share assets English
        window.open( data.osrscaRevenueShareImagesEn.payoutScheduleLink, "_blank");
      }
      else if ( $scope.languagePreference.toLowerCase() === 'fr' ) {
        // Dealer rev share assets French
        window.open(data.osrscaRevenueShareImagesFr.payoutScheduleLink, "_blank");
      }

    }).catch((err) => {
      console.log('Oops, error getting getJSONFileData' + err);
    });
  };
  $scope.getLatest_YR = function getLatest_YR(yr) {
    x3 = "";
    var s = yr;
    if (yr.includes("Step2")) {
      var s1 = s.replace("Step2", "");
      s = s1.replace("\n", "");
    }
    var x = s.replace("\n", "");
    var x1 = x.replace("\n", "");
    var x2 = x1.trim();
    var x3 = x2.substring((x2.length - 4), x2.length);
    return x3;
  };
  $scope.getLatest_YR_FR = function getLatest_YR_FR(yr) {
    var x = yr.replace("\n", "");
    x = x.replace(" ", "");
    x = x.replace(" ", "");
    x = x.replace(".", "");
    x = x.trim();
    x = x.substring(x.length - 4, x.length);
    return x.trim();
  };
  $scope.getLatest_MNTH = function getLatest_MNTH(mnth) {
    var x3 = "";
    var s = mnth;
    var s1 = "";
    if (mnth.includes("Step2")) {
      s1 = s.replace("Step2", "");
      s = s1.replace("\n", "");
    } else if(mnth.includes("LatestDate-MYP")) {
      s1 = s.replace("LatestDate-MYP", "");
      s = s1.replace("\n", "");
    } else if(mnth.includes("LatestDate-PreOwned")) {
      s1 = s.replace("LatestDate-PreOwned", "");
      s = s1.replace("\n", "");
    }
    var x = s.replace("\n", "");
    var x1 = x.replace("\n", "");
    var x2 = x1.trim();
    x3 = x2.substring(0, x2.length - 5);
    return x3;
  };
  $scope.getLatest_MNTH_FR = function getLatest_MNTH_FR(mnth) {
    var x = mnth.replace("\n", "");
    x = x.replace(" ", "");
    x = x.replace(" ", "");
    x = x.replace(".", "");
    x = x.trim();
    x = x.substring(24, x.length - 4);
    x = parseInt(x, 10);
    $scope.getLatest_QRTR_FRVAL = $scope.getLatest_QRTR_FR(x);
    switch (x) {
      case 1:
        x = "JANV";
        break;
      case 2:
        x = "FÉVR";
        break;
      case 3:
        x = "MARS";
        break;
      case 4:
        x = "AVRIL";
        break;
      case 5:
        x = "MAI";
        break;
      case 6:
        x = "JUIN";
        break;
      case 7:
        x = "JUILL";
        break;
      case 8:
        x = "AOÛT";
        break;
      case 9:
        x = "SEPT";
        break;
      case 10:
        x = "OCT";
        break;
      case 11:
        x = "NOV";
        break;
      case 12:
        x = "DÉC";
        break;
    }
    return x;
  };
  $scope.getLatest_QRTR = function getLatest_QRTR(qtr) {
    var x3 = "";
    if (qtr !== "") {
      if (qtr === "JANUARY" || qtr === "FEBRUARY" || qtr === "MARCH") {
        x3 = "Q1";
      } else if (qtr === "APRIL" || qtr === "MAY" || qtr === "JUNE") {
        x3 = "Q2";
      } else if (qtr === "JULY" || qtr === "AUGUST" || qtr === "SEPTEMBER") {
        x3 = "Q3";
      } else if (qtr === "OCTOBER" || qtr === "NOVEMBER" || qtr === "DECEMBER") {
        x3 = "Q4";
      }
    }
    return x3;
  };
  $scope.getLatest_QRTR_FR = function getLatest_QRTR_FR(qtr) {
    var x3 = "";
    if (qtr !== "") {
      if (qtr === 1 || qtr === 2 || qtr === 3) {
        x3 = "T1";
      } else if (qtr === 4 || qtr === 5 || qtr === 6) {
        x3 = "T2";
      } else if (qtr === 7 || qtr === 8 || qtr === 9) {
        x3 = "T3";
      } else if (qtr === 10 || qtr === 11 || qtr === 12) {
        x3 = "T4";
      }
    }
    return x3;
  };
  $scope.printTableData = function printTableData(vis,title) {
    var element = document.getElementById('myReport');
    var report = powerbi.get(element);
    var models = window['powerbi-client'].models;
    report.getPages().then(function(pages) {
      var activePage = pages.find(function(page) {
        return page.isActive;
      });
      activePage.getVisuals().then(function(visuals) {
        var visual = visuals.find(function(visual) {
          return visual.name === vis;
        });
        visual.exportData(models.ExportDataType.Summarized).then(function(result) {
          $scope.tableDataArray = [];
          var res = result.data.split("\n");
          var o = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i] !== "") {
              var res1 = res[i].toString();
              if (res1.length > 0) {
                var res2 = res1.split(",");
                $scope.tableDataArray.push(res2);
                o = o + 1;
              }
            }
          }
          if (visual.name === "674280155b92d03a1e44") {
            $scope.createHistoricalTable(title);
          } else if (visual.name === "fc0e82b5f50a7e42bbdb") {
            $scope.addVindetailTable(title);
          }
        }).catch(function(errors) {
          console.log(errors);
        });
      }).catch(function(errors) {
        console.log(errors);
      });
    }).catch(function(errors) {
      console.log(errors);
    });
  };
  $scope.printConsultCombineData = function printConsultCombineData() {
    var element = document.getElementById('myReport');
    var report = powerbi.get(element);
    var models = window['powerbi-client'].models;
    report.getPages().then(function(pages) {
      var activePage = pages.find(function(page) {
        return page.isActive;
      });
      activePage.getVisuals().then(function(visuals) {
        var visual = visuals.find(function(visual) {
          return visual.name === "b9a30854b5dba51afb54";
        });
        var visual2 = visuals.find(function(visual2) {
          return visual2.name === "fc0e82b5f50a7e42bbdb";
        });
        visual.exportData(models.ExportDataType.Summarized).then(function(result) {
          $scope.tableDataArray = [];
          var res = result.data.split("\n");
          var o = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i] !== "") {
              var res1 = res[i].toString();
              if (res1.length > 0) {
                var res2 = res1.split(",");
                $scope.tableDataArray.push(res2);
                o = o + 1;
              }
            }
          }
          $scope.addConsult1Table();
        }).catch(function(errors) {
          console.log(errors);
        });
        visual2.exportData(models.ExportDataType.Summarized).then(function(result) {
          $scope.tableDataArray2 = [];
          var res = result.data.split("\n");
          var o = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i] !== "") {
              var res1 = res[i].toString();
              if (res1.length > 0) {
                var res2 = res1.split(",");
                $scope.tableDataArray2.push(res2);
                o = o + 1;
              }
            }
          }
          $scope.addConsult2Table();
          $scope.print3Div();
        }).catch(function(errors) {
          console.log(errors);
        });
      }).catch(function(errors) {
        console.log(errors);
      });
    }).catch(function(errors) {
      console.log(errors);
    });
  };
  $scope.addVindetailTable = function addVindetailTable(title) {
    var div = document.getElementById('customtable1');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable1");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray[0];
    $scope.internalTableDataArray = [];
    for (var i = 0; i < $scope.tableDataArray.length; i++) {
      $scope.internalTableDataArray.push($scope.tableDataArray[i]);
    }
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = 'black';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      var res4 = $scope.internalTableDataArray[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '8px 35px 8px 45px';
        var dt = "";
        if (k === 0) {
          dt = $scope.dateFormat(res4[k]);
        } else {
          dt = res4[k];
        }
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
    $scope.printpreview("customtable1",title);
  };
  $scope.addConsult1Table = function addConsult1Table() {
    var div = document.getElementById('customtable1');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable1");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray[0];
    $scope.internalTableDataArray = [];
    for (var i = 0; i < $scope.tableDataArray.length; i++) {
      $scope.internalTableDataArray.push($scope.tableDataArray[i]);
    }
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = 'black';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      var res4 = $scope.internalTableDataArray[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        if ($scope.consult1SelectedValue === res4[0]) {
          tr.style.backgroundColor = '#F4D03F';
        }
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '8px 20px 8px 30px';
        if (k === 0) {
          td.style.width = '40%';
        }
        var dt = res4[k];
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };
  $scope.addConsult2Table = function addConsult2Table() {
    var div = document.getElementById('customtable2');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable2");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray2[0];
    $scope.internalTableDataArray2 = [];
    for (var i = 0; i < $scope.tableDataArray2.length; i++) {
      $scope.internalTableDataArray2.push($scope.tableDataArray2[i]);
    }
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = '#dddddd';
      th.style.color = 'black';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray2.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      var res4 = $scope.internalTableDataArray2[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '8px 20px 8px 30px';
        if (k === 0) {
          td.style.width = '40%';
        }
        var dt = res4[k];
        dt = "";
        if (k === 1) {
          dt = $scope.dateFormat(res4[k]);
        } else {
          dt = res4[k];
        }
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };

 $scope.print3Div = function print3Div() {
    var contents = document.getElementById("customtable3").innerHTML;
    var frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    frameDoc.document.open();
    if ($scope.usrlanguage === "en") {
      frameDoc.document.write('<html><head><title> CONSULTANT PERFORMANCE LEADERBOARD </title>');
    } else {
      frameDoc.document.write('<html><head><title> Rendement des conseillers </title>');
    }
    frameDoc.document.write('</head><body style="align-content: center;">');
    frameDoc.document.write(contents);
    frameDoc.document.write('</body></html>');
    frameDoc.document.close();
    setTimeout(function() {
      window.frames.frame1.focus();
      window.frames.frame1.print();
      document.body.removeChild(frame1);
    }, 900);
    return false;
  };

  $scope.createHistoricalTable = function createHistoricalTable(title) {
    $scope.qaulifiedArray = [];
    $scope.newVehicleArray = [];
    $scope.preOwnedVehicle = [];
    $scope.serviceLaneVehicle = [];
    $scope.qaulifiedSign = [];
    $scope.monthYr = [];
    $scope.monthYr[0] = "  ";
    var col,
        col1;
    for (var j = 1; j <= 12; j++) {
      col = $scope.tableDataArray[j].toString().split(",");
      $scope.monthYr.push(col[1]);
      $scope.qaulifiedSign.push(col[2]);
    }
    for (j = 13; j <= 24; j++) {
      col = $scope.tableDataArray[j].toString().split(",");
      col1 = col[2];
      $scope.newVehicleArray.push(col1);
    }
    for (j = 25; j <= 36; j++) {
      col = $scope.tableDataArray[j].toString().split(",");
      col1 = col[2];
      $scope.preOwnedVehicle.push(col1);
    }
    $scope.addHistoricalTable(title);
  };
  $scope.addHistoricalTable = function addHistoricalTable(title) {
    var div = document.getElementById('customtable1');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable1");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.monthYr;
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = '#191970';
      th.style.color = 'white';
      if (i === 0) {
        th.style.width = '15%';
      }
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (var i = 1; i < 5; i++) {
      tr = document.createElement('TR');
      var k,
          td,
          dt;
      if (i === 1) {
        td = document.createElement('TD');
        td.style.width = '20%';
        if ($scope.usrlanguage === "en") {
          dt = "*Qualified";
        } else {
          dt = "Qualifié";
        }
        td.style.padding = '3px 10px 3px 10px';
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
        for (k = 0; k < $scope.qaulifiedSign.length; k++) {
          td = document.createElement('TD');
          td.style.padding = '3px 10px 3px 10px';
          dt = $scope.qaulifiedSign[k];
          td.appendChild(document.createTextNode(dt));
          tr.appendChild(td);
        }
        tableBody.appendChild(tr);
      } else if (i === 2) {
        td = document.createElement('TD');
        if ($scope.usrlanguage === "en") {
          dt = "New Vehicle %";
        } else {
          dt = "Véhicules neufs %";
        }
        td.style.width = '20%';
        td.style.padding = '3px 10px 3px 10px';
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
        for (k = 0; k < $scope.newVehicleArray.length; k++) {
          td = document.createElement('TD');
          td.style.padding = '3px 10px 3px 10px';
          dt = $scope.newVehicleArray[k];
          td.appendChild(document.createTextNode(dt));
          tr.appendChild(td);
        }
        tableBody.appendChild(tr);
      } else if (i === 3) {
        td = document.createElement('TD');
        if ($scope.usrlanguage === "en") {
          dt = "Pre-Owned Vehicle %";
        } else {
          dt = "Véhicules d'occasion %";
        }
        td.style.width = '20%';
        td.style.padding = '3px 10px 3px 10px';
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
        for (k = 0; k < $scope.preOwnedVehicle.length; k++) {
          td = document.createElement('TD');
          td.style.padding = '3px 10px 3px 10px';
          dt = $scope.preOwnedVehicle[k];
          td.appendChild(document.createTextNode(dt));
          tr.appendChild(td);
        }
        tableBody.appendChild(tr);
      }
    }
    myTableDiv.appendChild(table);
   $scope.printpreview("customtable1",title);
  };
  $scope.dateFormat = function dateFormat(dte) {
    var changeddate = new Date(dte);
    var month = changeddate.getMonth() + 1;
    var day = changeddate.getDate();
    var year = changeddate.getFullYear();
    changeddate = month + "/" + day + "/" + year;
    return changeddate;
  };
  $scope.BrowserDetection = function BrowserDetection() {
    if (navigator.userAgent.search("MSIE")) {
      return "ie";
    } else if (navigator.userAgent.search("Chrome")) {
      return "chrome";
    } else if (navigator.userAgent.search("Firefox")) {
      return "firefox";
    } else {
      return "other";
    }
  };
  $scope.printEarningsCombineData = function printEarningsCombineData() {
    var element = document.getElementById('myReport');
    var report = powerbi.get(element);
    var models = window['powerbi-client'].models;
    report.getPages().then(function(pages) {
      var activePage = pages.find(function(page) {
        return page.isActive;
      });
      activePage.getVisuals().then(function(visuals) {
        var visual = visuals.find(function(visual) {
          return visual.name === "8f0a804b773b89db749b";
        });
        var visual2 = visuals.find(function(visual2) {
          return visual2.name === "fc0e82b5f50a7e42bbdb";
        });
        visual.exportData(models.ExportDataType.Summarized).then(function(result) {
          $scope.tableDataArray = [];
          var res = result.data.split("\n");
          var o = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i] !== "") {
              var res1 = res[i].toString();
              if (res1.length > 0) {
                var res2 = res1.split(",");
                $scope.tableDataArray.push(res2);
                o = o + 1;
              }
            }
          }
          if ($scope.usrlanguage === "en") {
            $scope.addEarningsDetail1Table();
          } else {
            $scope.addEarningsDetail1TableForFrench();
          }
        }).catch(function(errors) {
          console.log(errors);
        });
        visual2.exportData(models.ExportDataType.Summarized).then(function(result) {
          $scope.tableDataArray2 = [];
          var res = result.data.split("\n");
          var o = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i] !== "") {
              var res1 = res[i].toString();
              if (res1.length > 0) {
                var res2 = res1.split(",");
                $scope.tableDataArray2.push(res2);
                o = o + 1;
              }
            }
          }
          setTimeout(function() {
            if ($scope.usrlanguage === "en") {
              $scope.addEarningsDetail2Table();
              title="  EARNINGS DETAILS  ";
            } else {
              $scope.addEarningsDetail2TableForFrench();
              title=" Outil de renseignements sur les primes ";
            }
             $scope.printpreview("customtable6",title);
          }, 1000);
        }).catch(function(errors) {
          console.log(errors);
        });
      }).catch(function(errors) {
        console.log(errors);
      });
    }).catch(function(errors) {
      console.log(errors);
    });
  };
  $scope.addEarningsDetail1Table = function addEarningsDetail1Table() {
    var div = document.getElementById('customtable4');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    $scope.calculateEarningTotalRow();
    var myTableDiv = document.getElementById("customtable4");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray[0];
    $scope.internalTableDataArray = [];
    for (var i = 0; i < $scope.tableDataArray.length; i++) {
      $scope.internalTableDataArray.push($scope.tableDataArray[i]);
    }
    $scope.internalTableDataArray.push(["Total", $scope.earningsDetatilVehicles, $scope.earningsDetatilAvg, $scope.earningsDetatilEarnings]);
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = '#236B8E';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.style.textalign = 'center';
      th.style.aligncontent = 'center';
      th.style.alignself = 'center';
      th.style.justifycontent = 'center';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      if (i === ($scope.internalTableDataArray.length - 1)) {
        tr.style.color = 'blue';
      }
      var res4 = $scope.internalTableDataArray[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '5px 35px 5px 70px';
        var dt = res4[k];
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };
  $scope.addEarningsDetail2Table = function addEarningsDetail2Table() {
    var div = document.getElementById('customtable5');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable5");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.width = '100%';
    table.style.bordercollapse = 'collapse';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray2[0];
    $scope.internalTableDataArray2 = [];
    for (var i = 0; i < $scope.tableDataArray2.length; i++) {
      $scope.internalTableDataArray2.push($scope.tableDataArray2[i]);
    }
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = 'black';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.style.textalign = 'center';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray2.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      var res4 = $scope.internalTableDataArray2[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '5px 35px 5px 45px';
        var dt = res4[k];
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };
  $scope.calculateEarningTotalRow = function calculateEarningTotalRow() {
        $scope.earningsDetatilVehicles = "0";
        $scope.earningsDetatilAvg = "$0.0";
        var newVehicleArray = $scope.tableDataArray[1].toString().split(",");
        var preOwnedArray = $scope.tableDataArray[2].toString().split(",");
        var sumOfVehicles = Number(newVehicleArray[1]) + Number(preOwnedArray[1]);
        sumOfVehicles = Math.round(sumOfVehicles * 100) / 100;
        var sumTemp1 = Number(newVehicleArray[1]) / sumOfVehicles;
        var sumTemp2 = Number(preOwnedArray[1]) / sumOfVehicles;
        if(isNaN(sumTemp1))
            {
               sumTemp1=0;
            }
            if(isNaN(sumTemp2))
            {
               sumTemp2=0;
            }
        var multiTemp1 = Number(newVehicleArray[2].replace("$", "")) * sumTemp1;
        var multiTemp2 = Number(preOwnedArray[2].replace("$", "")) * sumTemp2;
        var avgVehicle = multiTemp1 + multiTemp2;
        avgVehicle = Math.round(avgVehicle * 100) / 100;
        var sumOfEarnings = Number(newVehicleArray[3].replace("$", "")) + Number(preOwnedArray[3].replace("$", ""));
        sumOfEarnings = Math.round(sumOfEarnings * 100) / 100;
        $scope.earningsDetatilVehicles = "" + sumOfVehicles;
        $scope.earningsDetatilAvg = "$" + avgVehicle;
        $scope.earningsDetatilEarnings = "$" + sumOfEarnings;
  };
  $scope.addEarningsDetail1TableForFrench = function addEarningsDetail1TableForFrench() {
    var div = document.getElementById('customtable4');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    $scope.calculateEarningTotalRowForFrench();
    var myTableDiv = document.getElementById("customtable4");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.bordercollapse = 'collapse';
    table.style.width = '100%';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray[0];
    $scope.internalTableDataArray = [];
    for (var i = 0; i < $scope.tableDataArray.length; i++) {
      $scope.internalTableDataArray.push($scope.tableDataArray[i]);
    }
    $scope.internalTableDataArray.push(["Total", $scope.earningsDetatilVehicles, $scope.earningsDetatilAvg, $scope.earningsDetatilEarnings]);
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = '#236B8E';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.style.textalign = 'center';
      th.style.aligncontent = 'center';
      th.style.alignself = 'center';
      th.style.justifycontent = 'center';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      if (i === ($scope.internalTableDataArray.length - 1)) {
        tr.style.color = 'blue';
      }
      var res4 = $scope.internalTableDataArray[i].toString().split(",");
      var k,
          td,
          dt;
      for (k = 0; k < res4.length; k++) {
        if (i === 1) {
          if (k === 0 || k === 1) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = res4[k];
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          } else if (k === 2) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = "$" + $scope.newVehicleEarngvalue2;
            dt = dt.replace('.', ',');
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          } else if (k === 3) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = "$" + $scope.newVehicleEarngvalue4;
            dt = dt.replace('.', ',');
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          }
        } else if (i === 2) {
          if (k === 0 || k === 1) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = res4[k];
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          } else if (k === 2) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = "$" + $scope.preOwnedEarngvalue2;
            dt = dt.replace('.', ',');
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          } else if (k === 3) {
            td = document.createElement('TD');
            td.style.bordercollapse = 'collapse';
            td.style.padding = '5px 35px 5px 70px';
            dt = "$" + $scope.preOwnedEarngvalue4;
            dt = dt.replace('.', ',');
            td.appendChild(document.createTextNode(dt));
            tr.appendChild(td);
          }
        } else if (i === 3) {
          td = document.createElement('TD');
          td.style.bordercollapse = 'collapse';
          td.style.padding = '5px 35px 5px 70px';
          dt = res4[k];
          dt = dt.replace('.', ',');
          td.appendChild(document.createTextNode(dt));
          tr.appendChild(td);
        }
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };
  $scope.addEarningsDetail2TableForFrench = function addEarningsDetail2TableForFrench() {
    var div = document.getElementById('customtable5');
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
    var myTableDiv = document.getElementById("customtable5");
    var table = document.createElement('TABLE');
    var tableBody = document.createElement('TBODY');
    table.border = '1';
    table.style.width = '100%';
    table.style.bordercollapse = 'collapse';
    table.appendChild(tableBody);
    var heading = $scope.tableDataArray2[0];
    $scope.internalTableDataArray2 = [];
    for (var i = 0; i < $scope.tableDataArray2.length; i++) {
      $scope.internalTableDataArray2.push($scope.tableDataArray2[i]);
    }
    var tr = document.createElement('TR');
    tableBody.appendChild(tr);
    for (i = 0; i < heading.length; i++) {
      var th = document.createElement('TH');
      th.style.backgroundColor = 'black';
      th.style.color = 'white';
      th.style.bordercollapse = 'collapse';
      th.style.padding = '8px';
      th.style.textalign = 'center';
      th.appendChild(document.createTextNode(heading[i]));
      tr.appendChild(th);
    }
    for (i = 1; i < $scope.internalTableDataArray2.length; i++) {
      tr = document.createElement('TR');
      tr.style.bordercollapse = 'collapse';
      var res4 = $scope.internalTableDataArray2[i].toString().split(",");
      for (var k = 0; k < res4.length; k++) {
        var td = document.createElement('TD');
        td.style.bordercollapse = 'collapse';
        td.style.padding = '5px 35px 5px 45px';
        var dt = res4[k];
        td.appendChild(document.createTextNode(dt));
        tr.appendChild(td);
      }
      tableBody.appendChild(tr);
    }
    myTableDiv.appendChild(table);
  };
  $scope.calculateEarningTotalRowForFrench = function calculateEarningTotalRowForFrench() {
    $scope.earningsDetatilVehicles = "0";
    $scope.earningsDetatilAvg = "$0.0";
    $scope.newVehicleEarngvalue2 = "";
    $scope.preOwnedEarngvalue2 = "";
    $scope.newVehicleEarngvalue4 = "";
    $scope.preOwnedEarngvalue4 = "";
    var newVehicleArray = $scope.tableDataArray[1].toString().split(",");
    var preOwnedArray = $scope.tableDataArray[2].toString().split(",");
    var sumOfVehicles = Number(newVehicleArray[1]) + Number(preOwnedArray[1]);
    sumOfVehicles = Math.round(sumOfVehicles * 100) / 100;
    var sumTemp1 = Number(newVehicleArray[1]) / sumOfVehicles;
    var sumTemp2 = Number(preOwnedArray[1]) / sumOfVehicles;
    if(isNaN(sumTemp1)){
       sumTemp1=0;
    }
    if(isNaN(sumTemp2)){
       sumTemp2=0;
    }
    var newVehicleArray2 = newVehicleArray[2].replace('"$', '');
    var newVehicleArray3 = newVehicleArray[3].replace('"', '');
    newVehicleArray2 = Number(newVehicleArray2 + "." + newVehicleArray3);
    var preOwnedArray2 = preOwnedArray[2].replace('"$', '');
    var preOwnedArray3 = preOwnedArray[3].replace('"', '');
    preOwnedArray2 = Number(preOwnedArray2 + "." + preOwnedArray3);
    $scope.newVehicleEarngvalue2 = newVehicleArray2;
    $scope.preOwnedEarngvalue2 = preOwnedArray2;
    var multiTemp1 = Number(newVehicleArray2) * sumTemp1;
    var multiTemp2 = Number(preOwnedArray2) * sumTemp2;
    var avgVehicle = multiTemp1 + multiTemp2;
    avgVehicle = Math.round(avgVehicle * 100) / 100;
    var newVehicleArray4 = newVehicleArray[4].replace('"$', '');
    var newVehicleArray5 = newVehicleArray[5].replace('"', '');
    newVehicleArray4 = Number(newVehicleArray4 + "." + newVehicleArray5);
    var preOwnedArray4 = preOwnedArray[4].replace('"$', '');
    var preOwnedArray5 = preOwnedArray[5].replace('"', '');
    preOwnedArray4 = Number(preOwnedArray4 + "." + preOwnedArray5);
    $scope.newVehicleEarngvalue4 = newVehicleArray4;
    $scope.preOwnedEarngvalue4 = preOwnedArray4;
    var sumOfEarnings = Number(newVehicleArray4) + Number(preOwnedArray4);
    sumOfEarnings = Math.round(sumOfEarnings * 100) / 100;
    $scope.earningsDetatilVehicles = "" + sumOfVehicles;
    $scope.earningsDetatilAvg = "$" + avgVehicle;
    $scope.earningsDetatilEarnings = "$" + sumOfEarnings;
  };
  $scope.getLatest_MNTH_FR2 = function getLatest_MNTH_FR2(mnth) {
    var x3 = "";
    var s = mnth;
    if (mnth.includes("step2")) {
      var s1 = s.replace("step2", "");
      s = s1.replace("\n", "");
    }
    var x = s.replace("\n", "");
    var x1 = x.replace("\n", "");
    var x2 = x1.trim();
    const mnthsRegex = /JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER/g;
    x3 = x2.match(mnthsRegex).toString();

    $scope.getLatest_QRTR_FRVAL2 = $scope.getLatest_QRTR_FR2(x3);
    switch (x3) {
      case "JANUARY":
        x3 = "JANV";
        break;
      case "FEBRUARY":
        x3 = "FÉVR";
        break;
      case "MARCH":
        x3 = "MARS";
        break;
      case "APRIL":
        x3 = "AVRIL";
        break;
      case "MAY":
        x3 = "MAI";
        break;
      case "JUNE":
        x3 = "JUIN";
        break;
      case "JULY":
        x3 = "JUILL";
        break;
      case "AUGUST":
        x3 = "AOÛT";
        break;
      case "SEPTEMBER":
        x3 = "SEPT";
        break;
      case "OCTOBER":
        x3 = "OCT";
        break;
      case "NOVEMBER":
        x3 = "NOV";
        break;
      case "DECEMBER":
        x3 = "DÉC";
        break;
    }
    return x3;
  };
  $scope.getLatest_QRTR_FR2 = function getLatest_QRTR_FR2(qtr) {
        var x3 = "";
        if (qtr !== "") {
          if (qtr === "JANUARY" || qtr === "FEBRUARY" || qtr === "MARCH") {
            x3 = "T1";
          } else if (qtr === "APRIL" || qtr === "MAY" || qtr === "JUNE") {
            x3 = "T2";
          } else if (qtr === "JULY" || qtr === "AUGUST" || qtr === "SEPTEMBER") {
            x3 = "T3";
          } else if (qtr === "OCTOBER" || qtr === "NOVEMBER" || qtr === "DECEMBER") {
            x3 = "T4";
          }
        }
        return x3;
  };
  $scope.getLatest_YR_FR2 = function getLatest_YR_FR2(yr) {
        var x = yr.replace("\n", "");
        x = x.replace(" ", "");
        x = x.replace(" ", "");
        x = x.replace(".", "");
        x = x.trim();
        x = x.substring(x.length - 4, x.length);
        return x;
  };
  $scope.calculateGoogleAnyalyticsTime = function calculateGoogleAnyalyticsTime(pageStartTime,eventTitle) {
        var reportLoaded = Date.now();
        var ttl=eventTitle+"==";
        timeDiff = (moment(reportLoaded).diff(moment(pageStartTime), 'milliseconds') / 1000);
         eventParameters = {
          'event_category': 'Report Loading Time',
          'event_label': timeDiff + ' seconds',
          'value': timeDiff
        };
        googleAnalyticsSvc.callGoogleAnalytics('event', '', '', ttl, eventParameters);
          //console.log(eventTitle+"=="+timeDiff);
      };
$scope.setActivepage = function setActivepage(report,pagenumber) {
 report.getPages()
    .then(function (pages) {
    pages[pagenumber].setActive().catch(function (errors) {
    console.log(errors);
    });
    }).catch(function (errors) {
     console.log(errors);
    });
};
 $scope.printpreview = function printpreview(customtable,title) {
     var contents = document.getElementById(customtable).innerHTML;
      var frame1 = document.createElement('iframe');
      frame1.name = "frame1";
      frame1.style.position = "absolute";
      frame1.style.top = "-1000000px";
      document.body.appendChild(frame1);
      var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
          frameDoc.document.open();
          frameDoc.document.write('<html><head><title> '+title+' </title>');
          frameDoc.document.write('</head><body style="align-content: center;">');
          frameDoc.document.write(contents);
          frameDoc.document.write('</body></html>');
          frameDoc.document.close();
          setTimeout(function () {
            window.frames["frame1"].focus(); // jshint ignore:line
            window.frames["frame1"].print(); // jshint ignore:line
            document.body.removeChild(frame1);
          }, 900);
      return false;
  };
$scope.hideVisualHeader = function hideVisualHeader(report,v1,v2) {
 var newSettings=null;
 if(v1 === undefined && v2 === undefined){ return; }
 if(v1 !== null && v2 === null){
  newSettings = {
   visualSettings: {
    visualHeaders: [
    {
    settings: {
      visible: false
    }},
    {
    settings: {
      visible: true
    },
    selector: {
      $schema: "http://powerbi.com/product/schema#visualSelector",
      visualName: v1
    }}]}};
  }else if(v1 !== null && v2 !== null){
   newSettings = {
    visualSettings: {
    visualHeaders: [{
    settings: {
      visible: false
    }},{
    settings: {
      visible: true
    },
    selector: {
     $schema: "http://powerbi.com/product/schema#visualSelector",
     visualName: v1
    }
   },{
    settings: {
     visible: true
    },
    selector: {
     $schema: "http://powerbi.com/product/schema#visualSelector",
     visualName: v2
    }}]}};
   }else{
     newSettings = {
     visualSettings: {
     visualHeaders: [{
      settings: {
       visible: false
      }}]}};
  }
 report.updateSettings(newSettings)
 .then(function () {
     //console.log("Visual header was successfully hidden for 'Category Breakdown' visual.");
 })
 .catch(function (error) {
     console.log(error);
 });
  };

})]);
//# sourceMappingURL=dealer-revenue-share.js.map
